module.exports = __webpack_public_path__ + "img/search-price.21b6a48.svg";